// Conctactless payment flow
export const CONTACTLESS_PAYMENT_WAITING_STAFF = "CONTACTLESS_PAYMENT_WAITING_STAFF"
export const CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS = "CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS"
export const CONTACTLESS_PAYMENT_CREATE_REQUEST = "CONTACTLESS_PAYMENT_CREATE_REQUEST"
export const CONTACTLESS_PAYMENT_CREATE_SUCCESS = "CONTACTLESS_PAYMENT_CREATE_SUCCESS"
export const CONTACTLESS_PAYMENT_CREATE_ERROR = "CONTACTLESS_PAYMENT_CREATE_ERROR"
export const CONTACTLESS_PAYMENT_RESET = "CONTACTLESS_PAYMENT_RESET"

// Conctactless payment poll flow
export const CONTACTLESS_PAYMENT_POLL_SUCCESS = "CONTACTLESS_PAYMENT_POLL_SUCCESS"
export const CONTACTLESS_PAYMENT_POLL_ERROR = "CONTACTLESS_PAYMENT_POLL_ERROR"
export const CONTACTLESS_PAYMENT_POLL_TIMEOUT = "CONTACTLESS_PAYMENT_POLL_TIMEOUT"
export const CONTACTLESS_PAYMENT_POLL_CANCEL = "CONTACTLESS_PAYMENT_POLL_CANCEL"

// Reader QR link flow
export const READER_LINK_QR_REQUEST = "READER_LINK_QR_REQUEST"
export const READER_LINK_QR_SUCCESS = "READER_LINK_QR_SUCCESS"
export const READER_LINK_QR_ERROR = "READER_LINK_QR_ERROR"

// Reader check linked flow
export const READER_CHECK_LINKED_REQUEST = "READER_CHECK_LINKED_REQUEST"
export const READER_CHECK_LINKED_SUCCESS = "READER_CHECK_LINKED_SUCCESS"
export const READER_CHECK_LINKED_ERROR = "READER_CHECK_LINKED_ERROR"

// Device models flow
export const READER_GET_DEVICE_MODELS_REQUEST = "READER_GET_DEVICE_MODELS_REQUEST"
export const READER_GET_DEVICE_MODELS_SUCCESS = "READER_GET_DEVICE_MODELS_SUCCESS"
export const READER_GET_DEVICE_MODELS_ERROR = "READER_GET_DEVICE_MODELS_ERROR"
export const READER_GET_DEVICE_MODELS_POLL_REQUEST = "READER_GET_DEVICE_MODELS_POLL_REQUEST"
export const READER_GET_DEVICE_MODELS_POLL_SUCCESS = "READER_GET_DEVICE_MODELS_POLL_SUCCESS"

// Delete device model flow
export const READER_DELETE_DEVICE_MODEL_REQUEST = "READER_DELETE_DEVICE_MODEL_REQUEST"
export const READER_DELETE_DEVICE_MODEL_SUCCESS = "READER_DELETE_DEVICE_MODEL_SUCCESS"
export const READER_DELETE_DEVICE_MODEL_ERROR = "READER_DELETE_DEVICE_MODEL_ERROR"

// Payment states from API
export const PAYMENT_STATE = {
  CREATED: 'created',
  CONFIRMED: 'confirmed',
  FAILED: 'failed',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in_progress',
} as const

export type PaymentState = typeof PAYMENT_STATE[keyof typeof PAYMENT_STATE]
